export default "__VITE_ASSET__DuluC8BF__"